
import React, { useEffect, useState, useRef } from 'react';

import type { ETicketDisplay } from '../../../tsrestapi/models';

interface PrepaidCardEticketMobileDisplayProps {
    eticket: ETicketDisplay,
    ratio?: number
}

export function PrepaidCardEticketMobileDisplay({ eticket, ratio = 0.58888 }: PrepaidCardEticketMobileDisplayProps) {
    const [cardHeight, setCardHeight] = useState(0);
    const cardRef = useRef(null);

    let cardWidth = 0;
    const setHeightByRatio = () => {
        if(cardWidth != cardRef.current.clientWidth) {
            cardWidth = cardRef.current.clientWidth;
            setCardHeight(cardRef.current.clientWidth / ratio);
        }
    };

    const listenResize = () => {
        window.addEventListener("resize", setHeightByRatio, false);
        setHeightByRatio();
    };
    useEffect(() => {
        listenResize();
    }, []);

    return <div className="giftcard-content" ref={cardRef} style={{height: cardHeight + "px"}}>
        <div className="giftcard-logo"></div>
        <div className="giftcard-amount">${eticket.PrepaidCardAmount}</div>
        <div className="giftcard-number">{eticket.PrepaidCardNumber}</div>
    </div>;
}